import React, { useEffect, useRef, useState } from "react";
import { BsFilterLeft } from "react-icons/bs";
import { FiChevronDown, FiChevronUp } from "react-icons/fi";
import { useClickOutside } from "../hook/clickOutside";
import { listFiltersResto } from "../types/types";
import './hookSortedPart.css'

interface HookSortedPartProps {
  fetchSections: (url: string, elem:string, options?: RequestInit, isInitialLoad?: boolean) => void;
  baseSortSection:string,
}

const HookSortedPart:React.FC<HookSortedPartProps> = ({fetchSections,baseSortSection}) => {
    const [showSortOptions,setShowSortOptions] = useState(false)
    const [currentSortOption,setCurrentSortOption] = useState(baseSortSection)
    const listSortOptions = ['Suggestions','Localisation','Type de restaurant']
    const refSortOption = useRef<HTMLDivElement>(null)
    const closeSortOption = () => {
        setShowSortOptions(false);
    }
    useClickOutside(refSortOption, showSortOptions, () => {
        closeSortOption()
    });
    

    useEffect(() => {
        if (!showSortOptions) return;
        const handleScroll = () => {closeSortOption();};
        window.addEventListener("scroll", handleScroll, {passive: true});
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [showSortOptions]);
    useEffect(() => {
        const popup = sortedPopupRef.current;
        if (!showSortOptions || !popup) return;
        let startY = 0;
        const onTouchStart = (e: TouchEvent) => {
            startY = e.touches[0].clientY;
        };

        const onTouchMove = (e: TouchEvent) => {
            const currentY = e.touches[0].clientY;
            const deltaY = currentY - startY;

            const atTop = popup.scrollTop <= 0;
            const atBottom =
            popup.scrollTop + popup.clientHeight >= popup.scrollHeight - 1;

            if ((atTop && deltaY > 0) || (atBottom && deltaY < 0)) {
            e.preventDefault();
            }
        };

        popup.addEventListener("touchstart", onTouchStart, { passive: true });
        popup.addEventListener("touchmove", onTouchMove, { passive: false });

        return () => {
            popup.removeEventListener("touchstart", onTouchStart);
            popup.removeEventListener("touchmove", onTouchMove);
        };
    }, [showSortOptions]);


    const handleClickSort = (elem:string,liste:string[]=[]) => {
        window.scrollTo({top: 0,behavior: "smooth"});
        closeSortOption();
        setCurrentSortOption(elem)
        
        if (elem === "Suggestions") {
        fetchSections("/api/getHomeSections",elem);
        return;
        }
        if (elem === "Localisation") {
        fetchSections("/api/getLocationSections",elem);
        return;
        }
        if (elem === "Type de restaurant") {
        fetchSections("/api/getTypeSections",elem);
        return;
        }
        if (liste.length > 0) {
        fetchSections("/api/getFilterSections",elem, {
            method: "POST",
            headers: {
            "Content-Type": "application/json"
            },
            body: JSON.stringify({
            categoryKey: elem,
            values: liste
            })
        });
        }
    }

    const sortedPopupRef = useRef<HTMLDivElement>(null);


    const listFitlersRestoUse = listFiltersResto.filter((elem) => ['Ambiance et expérience', 'Options pratiques'].includes(elem.value))

    return <div className="HookSortedPart XsmallText" ref={refSortOption}>
        <div className="selected midWhiteRoundButton pointer"  onClick={() => {
            const willOpen = !showSortOptions;
            setShowSortOptions(willOpen);
        }}>
            <BsFilterLeft size={18} className="allIcon"/>
            <span>{currentSortOption || 'Trier par'}</span>
            {showSortOptions ? <FiChevronUp size={18} className="icon allIcon" /> : <FiChevronDown size={18} className="icon allIcon" />}
        </div>
        {showSortOptions && <div className={`list primaryBack `} ref={sortedPopupRef} >
            <div className="classicPart">
                {listSortOptions.map((elem,id) => {
                return <span key={'sortOption'+id} className={`${(currentSortOption === elem || (elem === 'Suggestions' && !currentSortOption)) ? 'isSelect' : ''} pointer`} onClick={() => handleClickSort(elem)}>
                    {elem} 
                </span>
                })}
                {listFitlersRestoUse.map((elem,id) => {
                    return (
                        <span key={'sortOptionFilter'+id} className={`${currentSortOption === elem.value ? 'isSelect' : ''} pointer`} onClick={() => {const listeToSend = elem.value === 'Options pratiques' ? (elem.liste || []).filter( (item) => item !== 'Wifi disponible' && item !== 'Terrasse ombragée' ) : (elem.liste || []);handleClickSort(elem.value, listeToSend)}}>
                            {elem.value === 'Ambiance et expérience' ? 'Ambiance et exp...' : elem.value}
                        </span>
                    );
                })}
            </div>
            </div>}
    </div>
}

export default HookSortedPart